export const statusMapping = {
    "Scheduled": "ALL",
    "Completed": "COMPLETED",
    "Cancelled": "CANCELLED",
    "Re-scheduled": "RESCHEDULED"
};